<template>
  <div class="mt-5">
    <form @submit="submitForm" method="POST">
      <div class="mb-10">
        <h1 class="mb-3">Mortgage Referral Form</h1>
        <p>Fields marked with <span class="text-red">*</span> are required and must be filled in before continuing.</p>
      </div>
      <h3 class="mb-3">Agent Details</h3>

      <panel class="pt-5 mb-5">
        <div class="w-full flex mb-4">
          <div class="w-full flex flex-col">
            <label class="mb-2 text-sm">Office</label>
            <input :value="selectedOffice.name" class="input bg-white" type="text" name="office" disabled />
            <span v-if="errors.get('icid')" class="text-sm text-red my-1">{{ errors.get('icid') }}</span>
          </div>
        </div>

        <div class="w-full flex mb-4">
          <div class="w-full flex flex-col mr-4">
            <label class="mb-2 text-sm">Name <span class="text-red">*</span></label>
            <input v-model="details.name" class="input" type="text" name="name" />
          </div>

          <div class="w-full flex flex-col">
            <label class="mb-2 text-sm">Email <span class="text-red">*</span></label>
            <input v-model="details.email" class="input" type="text" name="email" />
            <span v-if="errors.get('email')" class="text-sm text-red my-1">{{ errors.get('email') }}</span>
          </div>
        </div>

        <div class="w-full flex">
          <div class=" flex flex-col">
            <label class="mb-2 text-sm">Agent Reference <span class="text-red">*</span></label>
            <input v-model="details.reference" class="input" type="text" name="reference" />
            <span v-if="errors.get('reference')" class="text-sm text-red my-1">{{ errors.get('reference') }}</span>
          </div>
        </div>
      </panel>

      <h3 class="mb-3">Customer Details</h3>

      <panel class="pt-5 mb-5">
        <div class="w-full flex mb-4">
          <div class="w-full flex flex-col mr-4">
            <label class="mb-2 text-sm">Name <span class="text-red">*</span></label>
            <input v-model="details.client_name" class="input" type="text" name="client_name" />
            <span v-if="errors.get('client_name')" class="text-sm text-red my-1">{{ errors.get('client_name') }}</span>
          </div>

          <div class="w-full flex flex-col">
            <label class="mb-2 text-sm">Telephone <span class="text-red">*</span></label>
            <input v-model="details.client_tel" class="input" type="text" name="client_tel" />
            <span v-if="errors.get('client_tel')" class="text-sm text-red my-1">{{ errors.get('client_tel') }}</span>
          </div>
        </div>

        <div class="w-full flex mb-4">
          <div class="w-full flex flex-col mr-4">
            <label class="mb-2 text-sm">Email <span class="text-red">*</span></label>
            <input v-model="details.client_email" class="input" type="text" name="client_email" />
            <span v-if="errors.get('client_email')" class="text-sm text-red my-1">{{ errors.get('client_email') }}</span>
          </div>

          <div class="w-full flex flex-col">
            <label class="mb-2 text-sm">Mobile</label>
            <input v-model="details.client_mobile" class="input" type="text" name="client_mobile" />
            <span v-if="errors.get('client_mobile')" class="text-sm text-red my-1">{{ errors.get('client_mobile') }}</span>
          </div>
        </div>

        <div class="w-full flex mb-4">
          <div class="w-full flex flex-col mr-4">
            <label class="mb-2 text-sm">Address Line 1 <span class="text-red">*</span></label>
            <input v-model="details.client_addr_1" class="input" type="text" name="client_addr_1" />
            <span v-if="errors.get('client_addr_1')" class="text-sm text-red my-1">{{ errors.get('client_addr_1') }}</span>
          </div>

          <div class="w-full flex flex-col">
            <label class="mb-2 text-sm">Address Line 2</label>
            <input v-model="details.client_addr_2" class="input" type="text" name="client_addr_2" />
            <span v-if="errors.get('client_addr_2')" class="text-sm text-red my-1">{{ errors.get('client_addr_2') }}</span>
          </div>
        </div>

        <div class="w-full flex mb-4">
          <div class="w-full flex flex-col mr-4">
            <label class="mb-2 text-sm">Address Line 3</label>
            <input v-model="details.client_addr_3" class="input" type="text" name="client_addr_3" />
            <span v-if="errors.get('client_addr_3')" class="text-sm text-red my-1">{{ errors.get('client_addr_3') }}</span>
          </div>

          <div class="w-full flex flex-col">
            <label class="mb-2 text-sm">Postcode <span class="text-red">*</span></label>
            <input v-model="details.client_addr_postcode" class="input" type="text" name="client_addr_postcode" />
            <span v-if="errors.get('client_addr_postcode')" class="text-sm text-red my-1">{{ errors.get('client_addr_postcode') }}</span>
          </div>
        </div>

        <div class="w-full flex mb-4">
          <div class="w-full flex flex-col">
            <label class="mb-2 text-sm">Preferred Call Time <span class="text-red">*</span></label>
            <pl-select v-model="details.preferred_call_time" name="preferred_call_time">
              <option value="9-12">09.00am - 12.00pm</option>
              <option value="12-13">12.00pm - 1.00pm</option>
              <option value="13-14">1.00pm - 2.00pm</option>
              <option value="14-17">2.00pm - 5.00pm</option>
              <option value="17-18">5.00pm - 6.00pm</option>
              <option value="18-20">6.00pm - 8.00pm</option>
              <option value="Any">Any time</option>
            </pl-select>
            <span v-if="errors.get('preferred_call_time')" class="text-sm text-red my-1">{{ errors.get('preferred_call_time') }}</span>
          </div>
        </div>

        <div class="w-full flex mb-4">
          <div class="w-full flex flex-col">
            <label class="mb-2 text-sm">Notes</label>
            <textarea v-model="details.notes" class="input" name="notes" rows="5"></textarea>
          </div>
        </div>
      </panel>

      <div class="w-full flex justify-end">
        <button class="button bg-secondary py-2">Submit Lead</button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ErrorBag from '@/ErrorBag'
import api from '@/http'

export default {
  data () {
    return {
      loading: false,
      errors: new ErrorBag(),
      details: {
        name: '',
        email: '',
        reference: '',
        client_name: '',
        client_email: '',
        client_tel: '',
        client_mobile: '',
        client_addr_1: '',
        client_addr_2: '',
        client_addr_3: '',
        client_addr_postcode: '',
        preferred_call_time: 'Any',
        notes: ''
      }
    }
  },

  mounted () {
    this.details.name = this.profile.name
    this.details.email = this.profile.email
  },

  computed: {
    ...mapState(['selectedOffice', 'profile'])
  },

  methods: {
    ...mapActions([
      'displayToastNotification'
    ]),
    submitForm (e) {
      e.preventDefault()
      this.errors.clear()

      if (this.loading) {
        return
      }

      this.loading = true
      api.post('landc/mortgage-lead', {
        office_id: this.selectedOffice.id,
        ...this.details
      }).then(({ data }) => {
        if (data.success) {
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'Request Submitted',
            info: `Your form has been submitted successfully.`
          })

          this.resetFields()
        } else {
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-warning',
            title: 'There was an error',
            info: `Your form has failed to submit, please try again shortly.`
          })
        }
      }).catch(error => {
        this.errors.store(error.response.data)
      }).finally(() => {
        this.loading = false
      })
    },

    resetFields () {
      this.details = Object.assign(this.details, {
        reference: '',
        client_name: '',
        client_email: '',
        client_tel: '',
        client_mobile: '',
        client_addr_1: '',
        client_addr_2: '',
        client_addr_3: '',
        client_addr_postcode: '',
        preferred_call_time: 'Any',
        notes: ''
      })
    }
  }

}
</script>
